"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserLogger = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _resolve = require("./resolve");

/* eslint-disable class-methods-use-this */
var BrowserLogger = /*#__PURE__*/function () {
  function BrowserLogger() {
    (0, _classCallCheck2.default)(this, BrowserLogger);
  }

  (0, _createClass2.default)(BrowserLogger, [{
    key: "error",
    value: function error(_error, context) {
      var _window$newrelic;

      var err = (0, _resolve.resolveError)(_error);
      err.name = "Browser".concat(err.name);
      console.error(err);
      (_window$newrelic = window.newrelic) === null || _window$newrelic === void 0 ? void 0 : _window$newrelic.noticeError(err, context);
    }
  }]);
  return BrowserLogger;
}();

exports.BrowserLogger = BrowserLogger;